export const LanguageIso6391 = {
  FR: "FR",
  EN: "EN",
  ZH: "ZH",
  PT: "PT",
  IT: "IT",
  ES: "ES",
  TR: "TR",
  NL: "NL",
  DE: "DE",
  AR: "AR",
  KO: "KO",
  JA: "JA",
  BE: "BE",
  RO: "RO",
  LT: "LT",
} as const

export type LanguageIso6391 =
  (typeof LanguageIso6391)[keyof typeof LanguageIso6391]

export enum ProductSheetLanguages {
  FR = "FR",
  EN = "EN",
  NL = "NL",
  DE = "DE",
  IT = "IT",
  ES = "ES",
  AR = "AR",
  KO = "KO",
  JA = "JA",
  BE = "BE",
  RO = "RO",
  LT = "LT",
  ZH = "ZH",
}
export type ProductSheetLanguage =
  (typeof ProductSheetLanguages)[keyof typeof ProductSheetLanguages]

export interface ActiveLanguages {
  [ProductSheetLanguages.EN]: boolean
  [ProductSheetLanguages.FR]: boolean
  [ProductSheetLanguages.DE]: boolean
  [ProductSheetLanguages.IT]: boolean
  [ProductSheetLanguages.ES]: boolean
  [ProductSheetLanguages.NL]: boolean
  [ProductSheetLanguages.AR]: boolean
  [ProductSheetLanguages.KO]: boolean
  [ProductSheetLanguages.JA]: boolean
  [ProductSheetLanguages.BE]: boolean
  [ProductSheetLanguages.RO]: boolean
  [ProductSheetLanguages.LT]: boolean
  [ProductSheetLanguages.ZH]: boolean
}

export const i18nProductSheetLocales = [
  "en",
  "fr",
  "de",
  "it",
  "es",
  "nl",
  "ar",
  "ko",
  "ja",
  "be",
  "ro",
  "lt",
  "zh",
] as const
export type i18nProductSheetLocale = (typeof i18nProductSheetLocales)[number]
